module.exports = __webpack_public_path__ + "img/Terraform-2-mobile.439d862e.png";